import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 22 22"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M16.5 19.937h-3.896v-4.813c0-.884-.72-1.604-1.604-1.604s-1.604.72-1.604 1.604v4.813H5.5c-2.216 0-3.437-1.221-3.437-3.438v-5.82c0-1.947.537-2.49 1.413-3.217l5.61-4.704a2.974 2.974 0 0 1 3.828 0l5.61 4.704c.876.727 1.413 1.271 1.413 3.216V16.5c0 2.217-1.22 3.438-3.437 3.438m-2.52-1.375h2.52c1.446 0 2.063-.617 2.063-2.063v-5.82c0-1.4-.232-1.591-.916-2.16L12.03 3.813c-.597-.5-1.465-.5-2.062 0L4.353 8.52c-.684.568-.915.76-.915 2.158V16.5c0 1.446.616 2.063 2.062 2.063h2.52v-3.438A2.983 2.983 0 0 1 11 12.145a2.983 2.983 0 0 1 2.98 2.98z"
    }, null, -1)
  ])))
}
export default { render: render }